import '../pages/Home.css';

function Home() {
    return (
      <div className="title-wrapper screen">
          <div className="main-content">
              <div className="content-wrapper">
                  <div className = "name-title title" >
                      <div className="first">SIENNA </div>
                      <div className="last">BROWN</div>
                      <div className="icon"><i className="fas fa-grin-tongue-squint"></i></div>
                  </div>
                  <div className="typewriter"><h1>Blah</h1></div>
                  <div className="button-wrapper">
                  </div>
              </div>
          </div>
      </div>
    );
  }
  
  export default Home;
